import { SET_AMENITIES, UPDATE_AMENITIES, AMENITY_FAILED } from '../../types';

const initialState = { amenities: [] };

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_AMENITIES:
            return {
                ...state,
                amenities: [...payload]
            };
        case UPDATE_AMENITIES:
            return {
                ...state,
                amenities: [...payload]
            };
        case AMENITY_FAILED:
            return {
                ...state,
                amenities: []
            };
        default:
            return state;
    }
}